export default "__VITE_ASSET__DvS6An8D__"